export const getYRange = (chartData, field) => {
    const minMax = chartData.reduce(
        (acc, point) => {
            return {
                min: Math.min(acc.min, point[field]),
                max: Math.max(acc.max, point[field]),
            };
        },
        { min: 999999, max: -999999 },
    );
    const range = minMax.max - minMax.min;
    const offset = range < 50 ? 5 : range < 100 ? 25 : 50;
    minMax.min = Math.max(0, minMax.min - offset);
    minMax.max = minMax.max + offset;
    const roundingFactor = minMax.max - minMax.min < 80 ? 10 : 100;
    minMax.min = Math.floor(minMax.min / roundingFactor) * roundingFactor;
    minMax.max = Math.ceil(minMax.max / roundingFactor) * roundingFactor;
    return minMax;
};
